import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { addAllVehiclesToGroup } from '../../services/GroupsService';
import { Group, AddAllVehiclesToGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, AddAllVehiclesToGroupRequest>;

function useAddVehiclesToGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(addAllVehiclesToGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAddVehiclesToGroup;
